import ErrorIndex from './error-index';

export default class ErrorIndexDesktop extends ErrorIndex {
    constructor(...args) {
        super(...args);
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/error/error-index.desktop.js